<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalThreshold from "../DesignerQuestionTechnicalThreshold.vue";
    import TileQuestion from "../mixin/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalThreshold,
            TileQuestion,
        ],
    }
</script>
